/*SYSTEM IMPORTS*/
import React, { Component } from "react"

// import ContTextEditor from './cont/TextEditor'

import * as WidgetList from "./list"

class Widgets extends Component {
    render() {
        const { props } = this
        const { widget } = props

        // if( widget == 'TextEditor' ) return <ContTextEditor {...props} />

        const WidgetItem = WidgetList[widget]

        if (WidgetItem) return <WidgetItem {...props} />

        return null
    }
}

export default Widgets
